// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Modal$OrcaPaymentPage from "./Modal.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as ClickToPayHelpers$OrcaPaymentPage from "../Types/ClickToPayHelpers.bs.js";

function ClickToPayLearnMore(props) {
  var match = React.useState(function () {
        return false;
      });
  var setOpenModal = match[1];
  var match$1 = React.useState(function () {
        return "";
      });
  var setCardBrand = match$1[1];
  var cardBrand = match$1[0];
  var logger = HyperLogger$OrcaPaymentPage.make(undefined, {
        TAG: "Elements",
        _0: "Payment"
      }, undefined, undefined, undefined, undefined);
  var closeClickToPayModal = function () {
    setOpenModal(function (param) {
          return false;
        });
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
            "fullscreen",
            false
          ]]);
  };
  React.useEffect((function () {
          ClickToPayHelpers$OrcaPaymentPage.loadClickToPayScripts(logger);
          var handle = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
            if (!Core__Option.isSome(dict["fullScreenIframeMounted"])) {
              return ;
            }
            var metadata = Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata"));
            var cardBrands = Utils$OrcaPaymentPage.getArray(metadata, "cardBrands").map(function (x) {
                      return Core__Option.getOr(Core__JSON.Decode.string(x), "");
                    }).filter(function (x) {
                    return x !== "";
                  }).join(",");
            if (cardBrands === "") {
              closeClickToPayModal();
            }
            setCardBrand(function (param) {
                  return cardBrands;
                });
          };
          window.addEventListener("message", handle);
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
  React.useEffect((function () {
          var handleClickToPayLearnMore = function (param) {
            closeClickToPayModal();
          };
          window.addEventListener("ok", handleClickToPayLearnMore);
          return (function () {
                    window.removeEventListener("ok", handleClickToPayLearnMore);
                  });
        }), []);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: cardBrand !== "",
              children: React.createElement("div", undefined, React.createElement(Modal$OrcaPaymentPage.make, {
                        children: React.createElement((function (prim) {
                                return React.createElement("src-learn-more", prim);
                              }), {
                              "card-brands": cardBrand
                            }),
                        showClose: false,
                        setOpenModal: setOpenModal,
                        openModal: match[0]
                      }))
            });
}

var make = ClickToPayLearnMore;

export {
  make ,
}
/* react Not a pure module */
